module.exports = __webpack_public_path__ + "static/turtle-creek-house25-583fd2c11e99e9d4db027674a82db7b5.jpg";